import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { isDirty } from 'redux-form';

import { askConfirmAction } from 'actions/confirm-action';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { pageRequest, updateSettingRequest } from 'actions/setting/checkout';
import MenuTitle from 'components/MenuTitle';
import withFeatureFlags from 'hocs/withFeatureFlags';
import CheckoutForm from './CheckoutForm';

class Checkout extends React.Component {
  componentDidMount() {
    this.props.dispatch(pageRequest());
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyCheckout && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  render() {
    return (
      <div>
        <div className="col-md-12 menu-title-checkout">
          <MenuTitle menuTitle="Checkout" />
        </div>
        <CheckoutForm onSubmit={this._onSubmit} />
        <ConfirmActionModal />
      </div>
    );
  }

  _onSubmit = values => {
    const { enableTaxConfiguration } = this.props;

    const data = { ...this.props.data.setting.checkout.setting };
    data.enable_tax = values.tax;
    data.enable_gratuity = values.gratuity;
    data.include_gratuity_tax = values.includeGratuityTax;
    data.track_server = values.trackServer;
    data.enable_rounding = values.rounding;
    data.is_stock_limit = values.isStockLimit;
    data.is_override_stock_limit =
      values.isStockLimit && values.isStockOverride;
    if (data.enable_rounding) {
      data.rounding_settings = {
        rounding_down_amount: values.roundingDownBelow,
        rounding_id: values.roundingOption,
      };
    }

    if (enableTaxConfiguration) {
      const newSetting = { ...data, outlets: values.outlets };
      this.props.dispatch(updateSettingRequest({ setting: newSetting }));
    } else {
      this.props.dispatch(updateSettingRequest({ settings: data }));
    }
  };
}

Checkout.propTypes = {};

function mapStateToProps(state) {
  return {
    isDirtyCheckout: isDirty('checkout')(state),
    nextAction: state.confirmAction.nextAction,
    form: state.form,
    data: {
      setting: {
        checkout: state.setting.checkout,
      },
    },
  };
}

const mapFlagsToProps = flags => ({
  enableTaxConfiguration: flags.enableTaxConfiguration,
});

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(Checkout)
);
